/**
 * PWA / install-prompt configuration.
 *
 * Values can be overridden at build time via Vite env vars
 * (e.g. `VITE_INSTALL_PROMPT_MIN_VIEWS=5`).
 */

function readNumber(value: string | undefined, fallback: number): number {
  if (value == null || value === "") return fallback;
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

export const pwaConfig = {
  /** Minimum number of pages a user must view before we ever surface
   *  the install prompt. Configurable via `VITE_INSTALL_PROMPT_MIN_VIEWS`. */
  installPromptMinPageViews: readNumber(
    import.meta.env.VITE_INSTALL_PROMPT_MIN_VIEWS,
    3,
  ),
} as const;
